import { Component } from '@angular/core';
import { AppService } from './app.service';
import { MessageService } from '../shared/message.service';
import { Location } from '@angular/common';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  host: { '(window:keydown)': 'hotkeys($event)' },
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'app';
  private visibleSave: boolean = false;
  private visibleLoad: boolean = false;
  public language: string = "de";



  get chapters():any[]{
    return this.appService.getAllTopics();
  }
  constructor(public appService: AppService, public messageService: MessageService, 
    public location: Location, protected http: HttpClient) {
      this.language = this.appService.languageAbbreviation;
   }


  /** get text in right language 
  * @param {string} tag - text to load
  */
  get(tag: string): String {
    return this.appService.get(tag);
  }

  /** calls the mathod to save the state */
  save() {
    if (this.appService.isTeachersPlaceVisible()) {
      this.appService.storeConfigTeacher();
    } else {
      this.appService.storeState();
    }
  }

  /** defines the hotkey Ctrl-S to prevent the default and store the correct file */
  hotkeys(event) {
    if (event.keyCode == 83 && event.ctrlKey) {
      event.preventDefault();
      this.save();
    }
  }

  /** closes the given alert */
  closeAlert(alert: any) {
    this.messageService.closeAlert(alert);
  }

  /** routes to the previous location */
  back() {
    this.location.back();
  }

  hasExercises(): boolean{
    return (this.appService.getAllTopics().length > 0);
  }

    /** store the configuration for student */
  storeConfigStudent(): void {
     this.appService.storeConfigStudent();
  }

  saveOption(): void{
    this.visibleSave = !this.visibleSave;
  }

  isSaveVisible():boolean{
    return this.visibleSave;
  }

  loadOption(): void{
    this.visibleLoad = !this.visibleLoad;
  }

  isLoadVisible():boolean{
    return this.visibleLoad;
  }

  loadStandardConfigTeacher(): void {
    let self = this;
    let filename: string = "./assets/" + this.language + "_book_config.json";

    this.http.get(filename).subscribe(result => {
      self.appService.configuration = result;
      self.appService.onLoadedConfig();
      self.appService.configuration.teachersplace = "true";
    });
  }

  loadConfigEmpty(): void {
    let self = this;
    let filename: string = "./assets/empty_config.json";

    this.http.get(filename).subscribe(result => {
      self.appService.configuration = result;
      self.appService.onLoadedConfig();
    });

  }


}
